import React, { Component } from "react";
import styles from "../../thema/style";
export default class Widget extends Component {
  render() {
    return (
      <div className={styles.widget}>
        <div className={"widget-title"}>{this.props.title}</div>
        <div className={"widget-content"}>{this.props.children}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Widget.js